import net from 'node:net'
import { execSync } from 'child_process'

/**
 * Finds the process name and PID using a port
 */
function findProcessOnPort(port: number): { pid: number; name: string } | null {
  try {
    const output = execSync(`lsof -ti :${port} 2>/dev/null`, { encoding: 'utf-8' })
    const pid = parseInt(output.trim().split('\n')[0] ?? '', 10)
    if (isNaN(pid)) return null

    let name = 'unknown'
    try {
      name = execSync(`ps -o comm= -p ${pid} 2>/dev/null`, { encoding: 'utf-8' }).trim()
    } catch { /* ignore */ }

    return { pid, name }
  } catch {
    return null
  }
}

/**
 * Checks whether a port is available.
 * If occupied, logs the offending process and fails with a clear message.
 */
export async function checkPortAvailable(port: number, host = '0.0.0.0'): Promise<void> {
  return new Promise((resolve, reject) => {
    const server = net.createServer()

    server.once('error', (err: NodeJS.ErrnoException) => {
      if (err.code === 'EADDRINUSE') {
        const proc = findProcessOnPort(port)
        const msg = proc
          ? `Port ${port} is already in use by "${proc.name}" (PID ${proc.pid}). Stop that process first.`
          : `Port ${port} is already in use`
        reject(new Error(msg))
      } else {
        reject(err)
      }
    })

    server.once('listening', () => {
      server.close(() => resolve())
    })

    server.listen(port, host)
  })
}
